const namedColors = { white: "ffffff", black: "000000", red: "ff0000", gray: "808080", grey: "808080", orange: "ffa500", yellow: "ffff00", green: "008000" };
const luminance = color => {
  if (typeof color !== "string") return null;
  let hex = color.trim().toLowerCase();
  hex = namedColors[hex] || hex.replace(/^#/, "");
  if (/^[0-9a-f]{3}$/.test(hex)) hex = hex.split("").map(value => value + value).join("");
  if (!/^[0-9a-f]{6}$/.test(hex)) return null;
  const channels = [0, 2, 4].map(offset => {
    const value = parseInt(hex.slice(offset, offset + 2), 16) / 255;
    return value <= 0.04045 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
  });
  return channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
};
export const contrastRatio = (foreground, background) => {
  const first = luminance(foreground), second = luminance(background);
  if (first === null || second === null) return 0;
  return (Math.max(first, second) + 0.05) / (Math.min(first, second) + 0.05);
};
// Keep a theme color when readable; otherwise choose a contrasting neutral.
export const readableText = (background = "#fff", ...preferred) => {
  const candidate = [...preferred, "#333333", "#ffffff", "#000000"].find(color => contrastRatio(color, background) >= 4.5);
  if (!candidate) return "#333333";
  return /^[0-9a-f]{3}([0-9a-f]{3})?$/i.test(candidate) ? "#" + candidate : candidate;
};

// Blend a theme accent into white for subtle badges.
export const lightTint = (color, strength = 0.12) => {
  let hex = typeof color === "string" ? color.trim().toLowerCase() : "";
  hex = namedColors[hex] || hex.replace(/^#/, "");
  if (/^[0-9a-f]{3}$/.test(hex)) hex = hex.split("").map(value => value + value).join("");
  if (!/^[0-9a-f]{6}$/.test(hex)) return "#f2f2f2";
  return "#" + [0, 2, 4].map(offset => Math.round(255 + (parseInt(hex.slice(offset, offset + 2), 16) - 255) * strength).toString(16).padStart(2, "0")).join("");
};

// Explicit theme text choices apply to solid primary actions only.
export const actionTextColor = (theme, background = theme.primaryColor) =>
  background === theme.primaryColor && theme.checkoutTextColor
    ? theme.checkoutTextColor
    : readableText(background, background === theme.primaryColor ? "#fff" : theme.cartFont, "#fff");
